import Target_0 from './src/Checkout.jsx';shopify.extend('purchase.checkout.cart-line-list.render-after', (...args) => Target_0(...args));